import { MenuPanelContext } from "./menu.panel.context.js";
import { c } from "react/compiler-runtime";
import { jsx } from "react/jsx-runtime";
import { useId, useLayoutEffect, useRef, useState } from "react";
//#region src/components/menu/menu.panel-navigator.tsx
var PREVIOUS_PANEL_OFFSET = -2;
var MenuPanelNavigator = (t0) => {
	const $ = c(25);
	const { children, defaultPanel, onPanelChange } = t0;
	let t1;
	if ($[0] !== defaultPanel) {
		t1 = [{ panel: defaultPanel }];
		$[0] = defaultPanel;
		$[1] = t1;
	} else t1 = $[1];
	const [path, setPath] = useState(t1);
	const pendingBackFocus = useRef(false);
	const pendingReturnPanel = useRef(void 0);
	const rootId = useId();
	let t2;
	if ($[2] !== defaultPanel || $[3] !== path) {
		t2 = path.at(-1) ?? { panel: defaultPanel };
		$[2] = defaultPanel;
		$[3] = path;
		$[4] = t2;
	} else t2 = $[4];
	const activeEntry = t2;
	let t3;
	if ($[5] !== rootId) {
		t3 = () => {
			const returnPanel = pendingReturnPanel.current;
			if (!returnPanel) return;
			pendingReturnPanel.current = void 0;
			[...document.querySelectorAll(`[data-menu-panel-root="${rootId}"]`)].find((trigger) => trigger.dataset.menuPanelTarget === returnPanel)?.focus();
		};
		$[5] = rootId;
		$[6] = t3;
	} else t3 = $[6];
	let t4;
	if ($[7] !== activeEntry.panel || $[8] !== rootId) {
		t4 = [activeEntry.panel, rootId];
		$[7] = activeEntry.panel;
		$[8] = rootId;
		$[9] = t4;
	} else t4 = $[9];
	useLayoutEffect(t3, t4);
	let t5;
	if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
		t5 = () => {
			const shouldFocus = pendingBackFocus.current;
			pendingBackFocus.current = false;
			return shouldFocus;
		};
		$[10] = t5;
	} else t5 = $[10];
	const consumeBackFocus = t5;
	let t6;
	if ($[11] !== onPanelChange) {
		t6 = (panel, focusBack) => {
			pendingBackFocus.current = focusBack;
			setPath((currentPath) => [...currentPath, { panel }]);
			onPanelChange?.(panel);
		};
		$[11] = onPanelChange;
		$[12] = t6;
	} else t6 = $[12];
	const navigate = t6;
	let t7;
	if ($[13] !== onPanelChange || $[14] !== path) {
		t7 = () => {
			if (path.length <= 1) return;
			const leavingEntry = path.at(-1);
			const previousEntry = path.at(PREVIOUS_PANEL_OFFSET);
			pendingBackFocus.current = false;
			pendingReturnPanel.current = leavingEntry?.panel;
			setPath(_temp);
			if (previousEntry) onPanelChange?.(previousEntry.panel);
		};
		$[13] = onPanelChange;
		$[14] = path;
		$[15] = t7;
	} else t7 = $[15];
	const back = t7;
	let t8;
	if ($[16] !== activeEntry.panel || $[17] !== back || $[18] !== navigate || $[19] !== path.length || $[20] !== rootId) {
		t8 = {
			activePanel: activeEntry.panel,
			back,
			consumeBackFocus,
			depth: path.length,
			navigate,
			rootId
		};
		$[16] = activeEntry.panel;
		$[17] = back;
		$[18] = navigate;
		$[19] = path.length;
		$[20] = rootId;
		$[21] = t8;
	} else t8 = $[21];
	let t9;
	if ($[22] !== children || $[23] !== t8) {
		t9 = /* @__PURE__ */ jsx(MenuPanelContext, {
			value: t8,
			children
		});
		$[22] = children;
		$[23] = t8;
		$[24] = t9;
	} else t9 = $[24];
	return t9;
};
function _temp(currentPath_0) {
	return currentPath_0.slice(0, -1);
}
//#endregion
export { MenuPanelNavigator };
